export default __webpack_public_path__ + "static/media/map.0610b5d6.jpg";